// Loads under node --test: errors.ts is import-free.
import { hasServerMessage, normalizeError } from '../../api/core/errors.ts';
import { maskId } from '../../auth/mask.ts';

/** The Lambda error shape the teacher gateway returns: an empty `message`, the text in `errorMessage`. */
function lambdaErrorMessage(data: unknown): string {
  const value = data && typeof data === 'object' ? (data as Record<string, unknown>).errorMessage : null;
  return typeof value === 'string' ? value : '';
}

/**
 * /teacher/signin answers 500 with `Mật khẩu không khớp` for a wrong password and `Người dùng không
 * tồn tại` for an email the vendor does not hold (a wrong vendor reads the same), so only the text tells them apart.
 */
export function teacherSignInErrorMessage(error: unknown, vendorId: string): string {
  const normalized = normalizeError(error);
  const text = (lambdaErrorMessage(normalized.data) || normalized.message).toLowerCase();
  if (normalized.kind === 'network') return 'Không kết nối được máy chủ IZTeach. Thầy/cô kiểm tra mạng rồi thử lại.';
  if (normalized.kind === 'timeout') return 'Máy chủ IZTeach phản hồi quá lâu. Thầy/cô thử lại sau ít phút.';
  if (text.indexOf('mật khẩu') >= 0) return 'Mật khẩu chưa đúng. Thầy/cô kiểm tra lại mật khẩu tài khoản IZTeach.';
  if (text.indexOf('không tồn tại') >= 0 || text.indexOf('vendor') >= 0) {
    // masked: the full id lives only under "Chi tiết kỹ thuật" on /setup
    const school = vendorId ? ` (mã trường ${maskId(vendorId)})` : '';
    return `Không tìm thấy tài khoản này trong trường đang cấu hình${school}. Kiểm tra lại email, hoặc báo quản trị viên kiểm tra mã trường nếu tài khoản thuộc trường khác.`;
  }
  if (normalized.kind === 'server') return 'Máy chủ IZTeach đang gặp sự cố. Thầy/cô thử lại sau ít phút.';
  if (normalized.kind === 'unauthorized' || normalized.kind === 'forbidden') return 'Email hoặc mật khẩu chưa đúng.';
  if (normalized.kind === 'validation') return 'Email hoặc mật khẩu chưa đúng định dạng.';
  if (hasServerMessage(normalized)) return normalized.message;
  return 'Không đăng nhập được IZTeach. Thầy/cô thử lại nhé.';
}
